<template>
  <div class="modal">
    <div class="modalclosebtn" @click="closemodal">
      <span></span>
      <span></span>
    </div>
    <div class="overlay" @click="closemodal"></div>
    <div class="modalimage">
      <slot name="image"></slot>
    </div>
  </div>
</template>

<script>
import "aframe";
import { lock, unlock } from "tua-body-scroll-lock";
export default {
  data() {
    return {};
  },
  mounted() {
    let modal = document.querySelector(".modal");
    lock(modal);
  },
  methods: {
    closemodal() {
      let modal = document.querySelector(".modal");
      this.$emit("my-click", false);
      unlock(modal);
    },
  },
};
</script>
<style lang="scss">
.modalimage {
  position: relative;
  & > img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-height: 100vh;
    min-width: 100vw;
  }
  & > a-scene {
    width: 100vw;
    height: 100vh;
  }
}
</style>
<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  .modalclosebtn {
    position: absolute;
    right: 0px;
    top: 0px;
    background-color: $blue;
    height: 60px;
    width: 60px;
    z-index: 9999;
    transition: 0.5s;
    &:hover {
      background-color: white;
      span {
        background-color: $blue;
      }
    }
    span {
      position: absolute;
      display: block;
      background-color: white;
      width: 2px;
      height: 70%;
      left: calc(50% - 1px);
      top: 15%;
      transform-origin: center center;
      transition: 0.5s;
      &:nth-child(1) {
        transform: rotate(45deg);
      }
      &:nth-child(2) {
        transform: rotate(-45deg);
      }
    }
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.overlay {
  background-color: rgba(255, 255, 255, 0.8);
}
</style>
